import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/usageDetailsReport'
import Component from 'components/Reports/UsageDetailsReport'

export default createListViewContainer({ actions, selectors: selectors.usageDetailsReport })(Component)
